export const INITIAL_STEP = "INITIAL_STEP";
export const IN_PROGRESS_STEP = "IN_PROGRESS_STEP";
export const SUCCESS_STEP = "SUCCESS_STEP";
export const SUCCESS_STEP_ALL = "SUCCESS_STEP_ALL";
export const ERROR_STEP = "ERROR_STEP";
